import ContactBlock from './ContactBlock';
import styles from './ContactSupportBlock.module.scss';

const ContactSupportBlock: React.FC = () => (
  <ContactBlock>
    <div className={styles.title}>
      スタディサプリ for PARENTSサポートセンター
    </div>
    <a
      href="https://studysapuri.jp/info/inquiry/parent/"
      rel="noopener noreferrer"
      target="_blank"
      className={styles.link}
    >
      お問い合わせフォーム
    </a>
    <ul className={styles.notes}>
      <li>
        お問い合わせフォームから
        <span className={styles.highlight}>
          学校の先生にメッセージを送ることはできません
        </span>
        。学校へ確認が必要な内容は直接学校へご連絡をお願いいたします。
      </li>
      <li>
        土日祝、ゴールデンウィーク、夏季休暇、年末年始はお休みをいただきます。お休み明けより順次対応いたしますため、お返事が遅れますことあらかじめご了承ください。
      </li>
    </ul>
  </ContactBlock>
);

export default ContactSupportBlock;
